import LocationModal from './location'

export default LocationModal
